"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { requestFcmPermission, fetchFcmToken, listenForForegroundMessages } from "@/core/notifications/fcm";
import { notificationRepository } from "../../data/repositories/notification.repository";
export function useFcmSetup() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
}
function _temp2() {
  let unsubscribe;
  const setup = async function setup() {
    const permission = await requestFcmPermission();
    if (permission !== "granted") {
      return;
    }
    const token = await fetchFcmToken();
    if (!token) {
      return;
    }
    try {
      await notificationRepository.registerFcmToken(token);
    } catch {}
    const unsub = await listenForForegroundMessages(_temp);
    if (typeof unsub === "function") {
      unsubscribe = unsub;
    }
  };
  setup();
  return () => {
    unsubscribe?.();
  };
}
function _temp(payload) {
  const p = payload as {
    notification?: {
      title?: string;
      body?: string;
    };
  };
  const title = p.notification?.title ?? "ItsHealer";
  const body = p.notification?.body ?? "";
  if ("Notification" in window && Notification.permission === "granted") {
    new Notification(title, {
      body,
      icon: "/images/logo.png"
    });
  }
}